import React from 'react';
import { HowItWorksConnections } from '../components/HowItWorksConnections';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { NarrativeSection } from '../components/NarrativeSection';
import { ToolComparison } from '../components/ToolComparison';
import { WallOfLove } from '../components/WallOfLove';
import { GettingStartedSteps } from '../components/GettingStartedSteps';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
import { AudienceSwitch } from '../components/AudienceSwitch';
import { NovaSection } from '../components/nova/NovaSection';
// New Giga home screen. The hero is the "Ask Giga anything, get it done."
// chat-box composer (HowItWorksConnections in hero mode), presented as a
// proper website hero. The Slack "@mention Giga" experience remains its own
// "Works where you work" section further down the page.
// The "AI Co-Pilot for Teams" homepage still lives at /future.
export function Home() {
  return <>
      <HowItWorksConnections mode="hero" data-id="element-4047" />
      <NovaSection data-id="element-4048" />
      <AudienceSwitch data-id="element-4049" />
      <LivesInSlack data-id="element-4050" />
      <ComputerUse data-id="element-4051" />
      <CapabilityGrid data-id="element-4052" />
      <NarrativeSection data-id="element-4053" />
      <ToolComparison data-id="element-4054" />
      <WallOfLove data-id="element-4055" />
      <GettingStartedSteps data-id="element-4056" />
      <PricingSection data-id="element-4057" />
      <ClosingCTA data-id="element-4058" />
    </>;
}